<template lang="pug">
#dashboard-operacao
    BaseHeader(titulo='Dashboard Operação', icon='el-icon-download')

    .view-container-base-header
        SessaoIndicadoresDashboard(
            :indicadores='sessaoIndicadores.indicadores',
            :loading='sessaoIndicadores.carregandoIdentificadores',
            :erro='sessaoIndicadores.erro'
        )
</template>

<script>
import BaseHeader from '@/components/BaseHeader';
import SessaoIndicadoresDashboard from '@/components/operacao/dashboard/SessaoIndicadoresDashboardOperacao.vue';
import OperacaoDashboardService from '@/services/OperacaoDashboardService';

export default {
    name: 'index',
    components: {
        SessaoIndicadoresDashboard,
        BaseHeader
    },
    data: () => ({
        sessaoIndicadores: {
            carregandoIdentificadores: false,
            erro: false,
            indicadores: []
        },

        filtros: {
            idsEmpresas: [],
            idsCategorias: [],
            dataCadastroInicio: null,
            dataCadastroFim: null,
            dataVigenciaInicio: null,
            dataVigenciaFim: null
        }
    }),
    mounted() {
        this.buscarIndicadores();
    },
    methods: {
        async buscarIndicadores() {
            this.sessaoIndicadores.carregandoIdentificadores = true;

            await OperacaoDashboardService.buscarIndicadores(this.filtros)
                .then(({ data }) => {
                    this.sessaoIndicadores.indicadores = data.indicadores;
                })
                .catch(() => {
                    this.$notify.error({
                        message: 'Não foi possível buscar os indentificadores.'
                    });
                    this.sessaoIndicadores.erro = true;
                })
                .finally(() => {
                    this.sessaoIndicadores.carregandoIdentificadores = false;
                });
        }
    }
};
</script>

<style lang="scss">
#dashboard-operacao {
    height: 100%;
    width: 100%;
}
</style>
